import React, {memo, useContext, useMemo} from 'react';
import {ThemeContext} from '../../apiContexts';
import LoadingBar from '../../components/loadingBar';
import ReactTable from '../../components/reactTable';
import {convertDistanceTo, convertSpeedTo, convertVolumeTo, nomenclatureDistance, nomenclatureSpeedOf, nomenclatureVolume} from '../../helpers/conversions';
import {durationFormat} from '../../helpers/date';
import {getColumnWidth} from '../../helpers/report';
import {ButtomStyled} from '../../styles';
import {Header, ListStyle} from './styles';

const SummaryList = ({
  className,
  data,
  timezone,
  onSelect,
  speedUnit,
  distanceUnit,
  volumeUnit,
  loading,
  ...props
}) => {
  const theme = useContext(ThemeContext);

  const columns = useMemo(
      () => [
        {
          Header: 'Nome',
          accessor: 'deviceName',
          minWidth: 200,
          width: getColumnWidth(data, 'deviceName', 'Nome'),
        },
        {
          Header: 'Distância',
          accessor: 'distance',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: 'Início do odômetero',
          accessor: 'startOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: 'Fim do odômetero',
          accessor: 'endOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: 'Velocidade Média',
          accessor: 'averageSpeed',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertSpeedTo(value, speedUnit)).toFixed(1) ||
            0} ${nomenclatureSpeedOf(speedUnit)}`,
        },
        {
          Header: 'Velocidade Máxima',
          accessor: 'maxSpeed',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertSpeedTo(value, speedUnit)).toFixed(1) ||
            0} ${nomenclatureSpeedOf(speedUnit)}`,
        },
        {
          Header: 'Horas ligado',
          accessor: 'engineHours',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: 'Gasto de Combustível',
          accessor: 'spentFuel',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertVolumeTo(value, volumeUnit)).toFixed(1) ||
            0} ${nomenclatureVolume(volumeUnit)}`,
        },
      ],
      [data],
  );

  const selectItem = (props) => onSelect(props);

  return (
    <ListStyle theme={theme} className="custom-shadow-2">
      <Header>
        <h5>Resumos</h5>
        <ButtomStyled
          theme={theme}
          outline
          className="custom-shadow custom-border btn-theme mb-3"
        >
          <span>Selecionar dispositivo</span>
        </ButtomStyled>
      </Header>
      {loading ? (
        <LoadingBar />
      ) : (
        <ReactTable
          data={data}
          columns={columns}
          selectItem={selectItem}
          listHeight={300}
        />
      )}
    </ListStyle>
  );
};

export default memo(SummaryList);
